/**
 * Привязка задачи к сделке CRM на новом бэке.
 *
 * `/v2/tasks/{id}/crm-links` отдаёт и принимает только id сделок, а сами
 * данные лежат в CRM-зеркале (`/crm/deals/list`) — там же, где их берут
 * планирование и слоты. Зеркало отдаёт сделку обогащённой: компания,
 * контакты, ответственный по имени, даты заявки и договора. Из этого и
 * собирается вкладка «Data».
 */
import { http } from '@/shared/api';
import type { SchemaV2 } from '@/shared/api';

export type CrmDealV2 = SchemaV2<'tasks_module_internal_crm.Deal'>;
export type CrmContactV2 = SchemaV2<'tasks_module_internal_crm.Contact'>;

/** Id сделок, привязанных к задаче. */
export async function fetchTaskCrmLinksV2(taskId: string): Promise<string[]> {
  const { data } = await http.get<{ result?: string[] }>(
    `/v2/tasks/${taskId}/crm-links`
  );

  return Array.isArray(data?.result) ? data.result : [];
}

export async function linkTaskToDealV2(
  taskId: string,
  dealId: string
): Promise<void> {
  await http.post(`/v2/tasks/${taskId}/crm-links`, { dealId });
}

export async function unlinkTaskFromDealV2(
  taskId: string,
  dealId: string
): Promise<void> {
  await http.delete(`/v2/tasks/${taskId}/crm-links/${dealId}`);
}

/** Сделки по списку id — обогащённые, как их отдаёт зеркало CRM. */
export async function fetchDealsByIdsV2(ids: string[]): Promise<CrmDealV2[]> {
  if (ids.length === 0) {
    return [];
  }
  const { data } = await http.get<{ result?: CrmDealV2[] }>('/crm/deals/list', {
    params: { ids: ids.join(','), limit: ids.length },
  });

  return Array.isArray(data?.result) ? data.result : [];
}

/** Поиск сделок для выбора привязки (в форме создания задачи). */
export async function searchDealsV2(
  search: string,
  limit = 20
): Promise<CrmDealV2[]> {
  const { data } = await http.get<{ result?: CrmDealV2[] }>('/crm/deals/list', {
    params: { title: search || undefined, limit, page: 1 },
  });

  return Array.isArray(data?.result) ? data.result : [];
}
